module.exports = __webpack_public_path__ + "img/SketchPng4863049fe87fc4b0c7a5ac123647f3bde456bc6fad812f739aba05636001c731.0ff7185a.png";